<template>

    <v-container class="fill-height" style="display: block;" fluid>

        <div class="release-notes-link-container mb-6">
            <v-icon class="mr-2">mdi-note-text</v-icon>
            <a href="https://releasenotes.telsasoft.com/?access=fdj*k38932jk" target="_blank">
                Latest Release Notes
            </a>
            <span class="new ml-2" v-if="newReleaseNotes">(NEW)</span>
        </div>

        <div class="motd-container">
            <v-textarea v-model="motd" style="margin-bottom: 0px;" :readonly="!motdPermissions" outlined label="Message of the Day" height="90" color="#c42111" no-resize @focus="motdFocused = true" @blur="motdFocused = false"></v-textarea>
            <div class="save-motd" :class="{focus: motdFocused}" @click="saveMotd" v-if="motdPermissions">
                <v-icon>mdi-content-save</v-icon>
            </div>
        </div>

        <div class="wysiwyg-container">

            <div id="edit-mode" v-if="!editMode">
                <!-- <v-btn fab small color="#c42111" @click="turnOnEditMode" v-if="motdPermissions"><v-icon>mdi-wrench</v-icon></v-btn> -->
                <v-btn small color="#c42111" @click="turnOnEditMode" v-if="motdPermissions"><v-icon class="mr-1" small>mdi-pencil</v-icon> Edit</v-btn>
            </div>
            <div id="edit-mode" v-if="editMode">
                <!-- <v-btn fab small color="#c42111" @click="turnOffEditMode"><v-icon>mdi-check</v-icon></v-btn> -->
                <v-btn class="mt-1" small color="#c42111" @click="turnOffEditMode"><v-icon class="mr-1" small>mdi-check</v-icon>Close Edit</v-btn>
            </div>

            <!-- <div id="save-content" v-if="editMode">
                <v-btn fab small color="#c42111" @click="saveHomePageContent"><v-icon>mdi-content-save</v-icon></v-btn>
            </div> -->


            <div id="editor-container">
                <div id="ckeditor" />
            </div>

        </div>


    </v-container>

</template>

<script>
import hash from 'object-hash';
import Editor from '@/ckeditor';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
    name: 'Home',
    props: [],
    components: {
    },
    data: () => ({
        defaultContent: '<p style="text-align:center;"><span style="font-size:48px;">Welcome to Telsasoft</span></p>',
        homePageContent: '',
        editMode: false,
        editorObj: null,

        toolbarWrapperElement: null,
        toolbarElement: null,

        editorConfig: {
            toolbar: {
                items: [
                    'heading',
                    '|',
                    'alignment',
                    '|',
                    'fontFamily',
                    'fontSize',
                    'fontColor',
                    'fontBackgroundColor',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'link',
                    '|',
                    'bulletedList',
                    'numberedList',
                    'todoList',
                    '|',
                    'indent',
                    'outdent',
                    '|',
                    'imageUpload',
                    'blockQuote',
                    'insertTable',
                    'mediaEmbed',
                    'undo',
                    'redo'
                ]
            },
            language: 'en',
            fontSize: {
                options: [9,11,12,14,16,18,24,32,36,48,72]
            },
            image: {
                toolbar: [
                    'imageTextAlternative',
                    'imageStyle:full',
                    'imageStyle:side'
                ]
            },
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells',
                    'tableCellProperties',
                    'tableProperties'
                ]
            },
            mediaEmbed: {
                previewsInData: true,
                toolbar: [
                    'undo',
                    'fontSize'
                ]
            },
            licenseKey: '',
        },

        motd: '',
        motdFocused: false,
        newReleaseNotes: false,
        saveButton: null
    }),

    computed: {
        motdPermissions: function() {
            return TELSA.checkPermission(this.$store.state.user, 'admin/edit-motd');
        }

    },

    methods: {
        getHomePageContent: function() {
            let route = (TELSA.apiHost + "settings/wysiwygcontent/home_page_content");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.homePageContent = result.wysiwyg_content;
                this.initializeEditor();
                TELSA.loading(false);
            });
        },

        initializeEditor: function() {
            ClassicEditor.create(document.getElementById('ckeditor'), this.editorConfig).then(editor => {
                this.editorObj = editor;
                this.toolbarWrapperElement = document.getElementsByClassName('ck ck-sticky-panel')[0];
                this.toolbarElement = document.getElementsByClassName('ck ck-toolbar__items') ? document.getElementsByClassName('ck ck-toolbar__items')[0] : null;

                this.turnOffEditMode();
                this.editorObj.setData(this.homePageContent);


                // Create save button
                this.createToolbarSeparator();
                this.createSaveButton();
            });
        },

        createToolbarSeparator: function(tool) {
            let separator = document.createElement('div');
            separator.innerHTML = `<span class="ck ck-toolbar__separator"></span>`;
            separator = separator.firstElementChild;
            this.toolbarElement.appendChild(separator);
        },

        createSaveButton: function() {
            

            this.saveButton = document.createElement('div');
            this.saveButton.innerHTML = `<button id="" class="ck ck-button ck-off" type="button" tabindex="-1" aria-labelledby="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd" aria-pressed="false">
                    <svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20"><path fill="#c42111" d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"></path></svg>
                    <span class="ck ck-tooltip ck-tooltip_s">
                        <span class="ck ck-tooltip__text">Save Content</span>
                    </span>
                    <span class="ck ck-button__label" id="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd">Save Content</span>
                </button>`;
            this.saveButton = this.saveButton.firstElementChild;
            this.saveButton.addEventListener("click", this.saveHomePageContent);

            // let toolbar = document.getElementsByClassName('ck ck-toolbar__items') ? document.getElementsByClassName('ck ck-toolbar__items')[0] : null;
            // console.log('toolbar: ', toolbar);
            // if(toolbar) {
            //     toolbar.appendChild(this.saveButton);
            // }
            this.toolbarElement.appendChild(this.saveButton);
        },

        createTagButton: function() {

        },

        createCustomButton: function() {
            let separator = document.createElement('div');
            separator.innerHTML = `<span class="ck ck-toolbar__separator"></span>`;
            separator = separator.firstElementChild;

            let button = document.createElement('div');
            button.innerHTML = `<button class="ck ck-button ck-off" type="button" tabindex="-1" aria-labelledby="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd" aria-pressed="false">
                    <svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"></path></svg>
                    <span class="ck ck-tooltip ck-tooltip_s">
                        <span class="ck ck-tooltip__text">Block quote</span>
                    </span>
                    <span class="ck ck-button__label" id="ck-editor__aria-label_e165209a029a9b7541e118f7bc50983cd">Block quote</span>
                </button>`;
            button = button.firstElementChild;

            let toolbar = document.getElementsByClassName('ck ck-toolbar__items') ? document.getElementsByClassName('ck ck-toolbar__items')[0] : null;
            console.log('toolbar: ', toolbar);
            if(toolbar) {
                toolbar.appendChild(separator);
                toolbar.appendChild(button);
            }
        },

        saveHomePageContent: function() {
            this.homePageContent = this.editorObj.getData();
            let route = (TELSA.apiHost + "settings/wysiwygcontent");
            TELSA.loading(true);
            return this.$http.post(route, {args: {wysiwyg_key: 'home_page_content', wysiwyg_content: this.homePageContent}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },

        turnOnEditMode: function() {
            this.editorObj.isReadOnly = false;
            this.toolbarWrapperElement.style.display = 'initial';
            document.getElementsByClassName('ck ck-content')[0].style.border = '#ffffff solid 1px';
            document.getElementsByClassName('ck ck-editor')[0].style.border = '#ffffff solid 1px';
            this.editMode = true;
        },

        turnOffEditMode: function() {
            this.editorObj.isReadOnly = true;
            this.toolbarWrapperElement.style.display = 'none';
            document.getElementsByClassName('ck ck-content')[0].style.border = 'none';
            document.getElementsByClassName('ck ck-editor')[0].style.border = 'none';
            this.editMode = false;
        },

        handleUpdatedCacheContent: function(event) {
            if(event.data.type == "CACHE_UPDATED" && event.data.payload.cacheName == "home-page-content") {
                caches.match(event.data.payload.updatedURL).then(resp => {
                    resp.text().then(updatedCachedContent => {
                        updatedCachedContent = JSON.parse(updatedCachedContent);
                        this.homePageContent = updatedCachedContent.wysiwyg_content;
                        this.editorObj.setData(this.homePageContent);
                    });
                });
            }
        },

        getMotd: function() {
            let route = (TELSA.apiHost + "settings/motd");
            //TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.motd = result;
                //TELSA.loading(false);
            });
        },

        saveMotd: function() {
            let lockName = `edit_motd`;
            this.$store.dispatch('getLock', lockName).then(lockOwner => {
                if(lockOwner) {
                    TELSA.loading(false);
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `Editing Message of the Day is locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot save any changes at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
                else {
                    let route = (TELSA.apiHost + "settings/motd");
                    TELSA.loading(true);
                    return this.$http.post(route, {args: {lock: this.$store.state.lock, motd: this.motd}}).then(response => {
                        let result = response.body;
                        this.$store.dispatch("handleRemoveLocks", {});
                        TELSA.loading(false);
                    });
                }
            });
        },

        checkForReleaseNotesUpdate: function() {
            let releaseNotesURL = "https://releasenotes.telsasoft.com/?access=fdj*k38932jk";
            let releaseNotesText = "";
            let releaseNotesHash = null;
            let latestHash = null;

            this.$store.dispatch('getConfigItem', {key: 'releasenoteshash'}).then(resp => {
                latestHash = resp.body;
                fetch(releaseNotesURL).then(resp => {
                    if(resp.status == 200) {
                        resp.text().then(text => {
                            releaseNotesText = text;
                            releaseNotesHash = String(hash(text));
                            this.newReleaseNotes = (latestHash != releaseNotesHash);
                            this.$store.dispatch('setConfigItem', {key: 'releasenoteshash', value: releaseNotesHash});
                        });
                    }
                });
            });            
        }
    },

    mounted() {
        this.getHomePageContent();
        this.getMotd();
        this.checkForReleaseNotesUpdate();
    },

    created() {
        // Setup handler for updating stale cached-content with latest content
        this.$workbox.addEventListener("message", this.handleUpdatedCacheContent);
    },

    destroyed() {
        this.editorObj.destroy().then(r => {
            this.editorObj.ui.view.toolbar.element.remove();
            this.editorObj.ui.view.editable.element.remove();
        });
        this.$workbox.removeEventListener("message", this.handleUpdatedCacheContent);
        this.saveButton.removeEventListener("click", this.saveHomePageContent);
    }
};
</script>

<style scoped>

    .home-title {
        font-size: 3rem !important;
        line-height: 3.125rem;
        font-weight: 700 !important;
        margin-bottom: 12px !important;
        letter-spacing: normal !important;
        font-family: "Roboto", sans-serif !important;
    }

    @media screen and (max-width: 600px) {
        .home-title {
            font-size: 2.125rem !important;
            line-height: 2.5rem;
            letter-spacing: 0.0073529412em !important;
            font-weight: 700 !important;
            margin-bottom: 12px !important;
            font-family: "Roboto", sans-serif !important;
        }
    }

    /* .release-notes-link-container {
        background-color: #424242;
        border: #000000 solid 1px;
        border-radius: 5px;
        width: 340px;
        padding: 10px;
        display: block;
        position: relative;
        box-shadow: 4px 4px 5px -2px rgb(0 0 0 / 60%);
    } */
    .release-notes-link-container {
        display: block;
    }
    .release-notes-link-container a {
        color: #ffffff;
        font-size: 22px;
        vertical-align: middle;
    }
    .release-notes-link-container i {
        font-size: 32px;
    }
    .release-notes-link-container .new {
        color: yellow;
        vertical-align: bottom;
    }

    .wysiwyg-container {
        position: relative;
    }

    #edit-mode {
        position: absolute;
        top: 0.1em;
        right: 1em;
        z-index: 2;
    }

    #save-content {
        position: absolute;
        top: 0.1em;
        right: 4em;
        z-index: 2;
    }

    .motd-container {
        position: relative;
    }

    .save-motd {
        /* position: absolute;
        bottom: 30px;
        right: 0; */

        position: absolute;
        bottom: 30px;
        right: 0px;
        /* background-color: #c42111; */
        cursor: pointer;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border: solid #ffffff 1px;
    }

    .save-motd.focus {
        border: solid #c42111 1px;
        background-color: #c42111;
    }

</style>

<style>
    main .ck-editor[role='application'] .ck.ck-content {
        color: #fff;
        background-color: #303030;
        height: calc(100vh - 300px);
        border: none;
    }

    .ck .ck-content .media.ck-widget {
        /* width: 50% !important; */
    }

</style>
